<template>

  <div id="app">
    <Header></Header>
    <Hero image="/static/img/careers.jpg"></Hero>
    <section class="content container">
      <h3>Careers</h3>


      <h4>Digital Manager</h4>



      <p>
        As Shamal Communications Digital Manager, you will be responsible for
        developing strategies, producing quality content, analysing usage data, and
        managing projects and campaigns for a diverse range of B2B and B2C clients
        as part of a busy communications team.
      </p>
      <p>
        The successful applicant will manage a range of existing digital accounts
        and be instrumental in driving account wins.
      </p>
      <p>
        <strong>Responsibilities</strong>
        <strong></strong>
      </p>
      <p>
        As Digital Manager, you will have responsibility for:
      </p>
      <ul type="disc">
        <li>
          Developing creative and engaging digital strategies
        </li>
        <li>
          Managing the day-to-day handling of all client social media channels
          such as LinkedIn, Facebook, Twitter, and Instagram, adapting content to
          suit different channels
        </li>
        <li>
          Oversee, plan and deliver content across different platforms using
          scheduling tools
        </li>
        <li>
          Create engaging multimedia content across multiple platforms by working
          with clients or outsourcing
        </li>
        <li>
          Manage paid-for digital campaigns including geo-targeted
          lead-generation, SEO, boosting and advertising.
        </li>
        <li>
          Develop key relationships with influencers across the social media
          platforms
        </li>
        <li>
          Undertake audience research
        </li>
        <li>
          Manage and facilitate social media communities by responding to social
          media posts and developing discussions
        </li>
        <li>
          Monitor, track, analyse and report on performance on social media
          platforms using tools such as Google Analytics and Facebook insights
        </li>
        <li>
          Research and evaluate the latest trends and techniques to find new and
          better ways of measuring social media activity
        </li>
        <li>
          Analyse competitor activity
        </li>
        <li>
          Recommend improvements to increase performance
        </li>
        <li>
          Set targets to increase brand awareness and increase customer
          engagement
        </li>
        <li>
          Manage a budget for social media activities
        </li>
        <li>
          Educate other staff on the use of social media and promote its use
          within the agency
        </li>
        <li>
          Regularly liaise with clients
        </li>
        <li>
          Attend networking events and relevant business group meetings
        </li>
        <li>
          Develop plans for new business acquisition
        </li>
      </ul>
      <p>
        <strong>Skills required:</strong>
        <strong></strong>
      </p>
      <p>
        <strong> </strong>
      </p>
      <ul type="disc">
        <li>
          A solid understanding of the use of a range of social media platforms,
          particularly in relation to advertising/branding and customers
        </li>
        <li>
          Strong copywriting and editing skills suitable for each platform, from
          knowing how to write a successful tweet to using effective storytelling
          techniques
        </li>
        <li>
          Knowledge and understanding of algorithms and search engine
          optimisation
        </li>
        <li>
          Creative skills for contributing new and innovative ideas
        </li>
        <li>
          Strong communication and people skills for articulating ideas to
          colleagues and clients
        </li>
        <li>
          Excellent team working, collaboration and networking skills
        </li>
        <li>
          Organisational skills, with the capacity to prioritise and work across
          multiple projects
        </li>
        <li>
          Project and campaign management skills
        </li>
        <li>
          Skills in data analysis and interpreting statistics
        </li>
        <li>
          An eye for detail and the ability to work accurately
        </li>
        <li>
          A good understanding of regional industry trends that have the
          potential to impact clients
        </li>
        <li>
          Solid business acumen and commercial awareness
        </li>
        <li>
          Fluent in English, working knowledge of Arabic would also be an
          advantage
        </li>
      </ul>

      <p>
        The successful candidate will work closely with all teams within Shamal
        Communications and report to the General Manger. You will be based in the heart
        of the hustle and bustle of Jumeirah Lakes Towers, with good
         transport links just a short walk away.


      </p>
     


    </section>

    <Footer></Footer>
  </div>


</template>

<script>

import Header from "./components/Header";
import Logos from "./components/Logos";
import BlockA from "./components/BlockA";
import Footer from "./components/Footer";
import BlockB from "./components/BlockB";
import Hero from "./components/Hero";
import BlockC from "./components/BlockC";
import Carousel from "./components/Carousel";

export default {
  name: 'app',

  data: () => ({}),
  components: {
    Carousel,
    BlockC,
    Hero,
    BlockB,
    Footer,
    BlockA,
    Logos,
    Header,


  }
}
</script>
<style scoped>
.content {
  padding: 40px;
  background: #fff;
}

h3 {
  margin: 20px 0;
}
</style>
